export const SEARCH_LEGAL_ENTITIES = 'SEARCH_LEGAL_ENTITIES';
export const LOGIN_AS_COMPANY_AS_ADMIN = 'LOGIN_AS_COMPANY_AS_ADMIN';
